module.exports = __webpack_public_path__ + "static/media/trash.9e12a457.svg";